export default __webpack_public_path__ + "static/media/person_2@3x.47b80432.png";